import { cn } from '@commenda/utils';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const labelVariants = cva(
  'flex items-center gap-0.5 txt-small-medium text-text-secondary peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
);

type LabelOwnProps = { required?: boolean; optional?: boolean };

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> &
    LabelOwnProps
>(({ className, children, required, optional, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  >
    {children}
    {required && (
      <span aria-hidden className="text-text-error ml-0.5">
        *
      </span>
    )}
    {optional && (
      <span className="ml-0.5 font-normal text-text-tertiary">(optional)</span>
    )}
  </LabelPrimitive.Root>
));

Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
